import React from 'react';
import DashboardHeader from './DashboardHeader';

const DashboardPage = ({
  ariaLabel,
  title,
  subtitle,
  enabled,
  queries,
  hasCompleteData,
  children,
  headerContent = null,
  contentClassName = 'space-y-4',
  errorMessage = 'Actualisation incomplète',
}) => {
  const refreshing = queries.some((query) => query.isFetching);
  const allQueriesSucceeded = queries.every((query) => query.isSuccess);
  const hasError = queries.some((query) => query.isError) || (allQueriesSucceeded && !hasCompleteData);
  const updatedAt =
    allQueriesSucceeded && hasCompleteData ? Math.min(...queries.map((query) => query.dataUpdatedAt)) : null;

  return (
    <section
      className="min-h-screen w-full bg-[#f7f9fa] px-4 py-6 [font-family:Inter,sans-serif] text-sm text-[#1d2824] sm:px-6 lg:px-10 lg:py-[30px]"
      aria-label={ariaLabel}
    >
      {headerContent}
      <DashboardHeader
        title={title}
        subtitle={subtitle}
        refreshing={refreshing}
        error={hasError && errorMessage}
        updatedAt={updatedAt}
      />
      {!enabled ? (
        <p role="alert">Le contexte de campagne ou d’appartenance est indisponible.</p>
      ) : (
        <div className={`mx-auto max-w-[1480px] ${contentClassName}`}>{children}</div>
      )}
    </section>
  );
};

export default DashboardPage;
